import React  from 'react';

const PrevArrow = (props) => (
    <div {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="42" height="27" viewBox="0 0 42 27" fill="none">
        <path d="M0.833252 13.7355C0.858981 14.0227 0.979231 14.4061 1.17179 14.6211L11.328 26.091C11.7711 26.6903 12.6845 26.6883 13.2467 26.1982C13.8089 25.7079 13.8517 24.837 13.3593 24.3199L5.17078 15.0849H40.1041C40.8519 15.0849 41.4583 14.4808 41.4583 13.7355C41.4583 12.9903 40.8519 12.3861 40.1041 12.3861H5.17078L13.3593 3.15121C13.8966 2.63412 13.7455 1.74729 13.1833 1.25712C12.6211 0.76695 11.7711 0.801908 11.328 1.38012L1.17179 12.85C0.900351 13.143 0.848554 13.461 0.833252 13.7355Z" fill="#AC8BD5"/>
      </svg>
    </div>
  );
export default PrevArrow;